// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/sass/style.scss
// module id = 7
// module chunks = 0